$(document).ready(function($) {

    var url = [];

    url['education'] = '/users/education/delete';
    url['employment'] = '/users/employment/delete';
    url['languages'] = '/users/user-languages/delete';
    url['skills'] = '/users/skills/delete';
    
    var langUrl = $("#lang-url").val();

    $(document).on("click", ".remove-item", function(e) {
        var id = $(this).attr('data-id');

        $.ajax({
            type: "POST",
            url: url[$(this).attr('data-type')],
            data: {
                id: id,
            },
            success: function () {
                window.location.reload(true);
            }
        });
    });

    $(document).on("click", ".remove-detail-item", function(e) {
        var id = $(this).attr('data-id');

        $.ajax({
            type: "POST",
            url: url[$(this).attr('data-type')],
            data: {
                id: id,
            },
            success: function () {
                // window.location.reload(true);
            }
        });
    });




    $(".dynamicform_wrapper").on("afterInsert", function(e, item) {
        $(item).find('.select-input2').select2("val", "");
        $(item).find('.remove-item').attr('data-id', null);

        var selects = $(item).find('select');
        $.each(selects, function(index, value) {
            $('#'+value.id+' option:selected').removeAttr("selected");
        });

        $(item).find(".company-end-period").removeClass("hide");
        $(item).find(".still-working").removeAttr("checked");

        addRequired($(item));
        yearsValidation($(item));
        addAutocomplate($(item));

        $("#download_from_ln").removeClass('hide');

        $('.text-area-field').wysihtml5();
    });


    $(".dynamicform_wrapper_education").on("afterInsert", function(e, item) {
        var selects = $(item).find('select');
        $.each(selects, function(index, value) {
            $('#'+value.id+' option:selected').removeAttr("selected");
        });

        $(item).find('.remove-item').attr('data-id', null);

        $(item).find(".education-end-period").removeClass("hide");
        $(item).find(".still-working").removeAttr("checked");

        addRequired($(item));
        yearsValidation($(item));

        $('.text-area-field').wysihtml5();
    });



    $(".example_id").each(function (i) {
        $(this).ionRangeSlider({
            grid: true,
            from: $(this).val() - 1,
            values: value,
            onFinish: function (data) {
                data.input.next("input").attr("value", value.indexOf(data.from_value) + 1);
            }
        });
    });



    $(".btn-add-soft-skills ").on("click", function (e) {
        e.preventDefault();

        // $(this).addClass("hide");
        $(".soft-skills-panel").removeClass("hide");
    });


    function yearsValidation(obj){

        obj.each(function (i) {
            var start_year = $(this).find(".start_year");
            var end_year =  $(this).find(".end_year");

            var start_month =  $(this).find(".start_month");
            var end_month =  $(this).find(".end_month");

            var values = end_year.find("option");


            values.each(function (i) {
                if($(this).val() < start_year.val()){
                    $(this).addClass('hide');
                }
            });

            start_year.on("change", function () {
                var values = end_year.find("option");

                values.each(function (i) {
                    if($(this).val() < start_year.val()){
                        $(this).addClass('hide');
                        $(this).removeAttr("selected");
                    }else{
                        $(this).removeClass('hide');
                    }
                });
                checkMonts(start_month, start_year, end_month, end_year);
            });



            start_month.on("change", function () {
                checkMonts(start_month, start_year, end_month, end_year);
            });


            end_year.on("change", function () {
                checkMonts(start_month, start_year, end_month, end_year);
            });
        });
    }

    function checkMonts(start_month, start_year, end_month, end_year) {
        //end_month.append(start_month.find("option"));
        var values = end_month.find("option");


        if(start_year.val() == end_year.val()){
            values.each(function (i) {
                if(parseInt($(this).val()) < parseInt(start_month.val())){
                    $(this).addClass('hide');
                    $(this).removeAttr("selected");
                }else{
                    $(this).removeClass('hide');
                }
            })
        }else{
            values.each(function (i) {
                $(this).removeClass('hide');
            })
        }
    }

    function addAutocomplate(obj) {
        var field = $(obj).find(".company_title_detail");
        var selectedItemValue;
        var langUrl = 'en';

        var options = {
            url: "/" + langUrl + "/companies/companies/get-companies-for-ajax",
            getValue: function (element) {
                return element.name;
            },
            list: {
                match: {
                    enabled: true
                },
                onSelectItemEvent: function () {
                    selectedItemValue = field.getSelectedItemData();
                },
                onHideListEvent: function () {

                }
            },
            theme: "square"
        };

        field.easyAutocomplete(options);
    }



    $(".dynamicform_wrapper").on("afterDelete", function(e) {
        $(this).find('.user-id').remove();

        if($(this).find(".employmentHistory").html() == undefined){
            $("#download_from_ln").addClass('hide');
        }
    });

    $(".dynamicform_wrapper_education").on("afterDelete", function(e) {
        $(this).find('.user-id').remove();
    });


    function addRequired(obj) {
        obj.find('.end_year').addClass('required-field');
        obj.find('.end_month').addClass('required-field');
    }

    function scrollToElement(obj) {
        $('html, body').animate({
            scrollTop: obj.offset().top
        }, 500);
    }

    $(document).on("submit", "#job-alerts-create-form", function (e) {
        var fields = $(this).find(".required-alert");
        var emptyFields = 0;

        fields.each(function (x) {
            if ($(this).val() == null || $(this).val() == '') {
                emptyFields ++;
            }
        });

        if (emptyFields >= 3) {
            e.preventDefault();
            fields.parent(".form-group").removeClass("has-success").addClass("has-error required");
        } else {
            fields.parent(".form-group").removeClass("has-error required").addClass("has-success");
        }
    });

});